import React, { useState } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnUrl = searchParams.get('returnUrl');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(email, password);
    if (result.success) {
      toast.success('Welcome back!');
      navigate(returnUrl || '/dashboard');
    } else {
      toast.error(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src="https://customer-assets.emergentagent.com/job_2decf1d9-6688-4b47-98c1-1893beae897a/artifacts/lr28yf8y_43425DE4-4AE4-4784-89F6-4AA746534747.png"
            alt="Show Master Logo"
            className="h-[120px] w-[120px] mx-auto mb-4"
          />
          <h1 className="text-3xl font-black text-white mb-2" style={{fontFamily: 'Outfit'}}>Welcome Back</h1>
          <p className="text-[#9E9E9E]">Login to manage your shows</p>
        </div>

        <div className="bg-[#161616] border border-[#262626] rounded-lg p-8">
          <form onSubmit={handleSubmit} data-testid="login-form" className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-[#F8F8F8] mb-2">Email</label>
              <input
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-3 bg-[#0A0A0A] border border-[#262626] rounded-md text-white placeholder-[#525252] focus:outline-none focus:border-[#0096FF] transition-colors"
                placeholder="your@email.com"
              />
            </div>

            <div>
              <div className="flex items-center justify-between mb-2">
                <label className="block text-sm font-medium text-[#F8F8F8]">Password</label>
                <Link to="/forgot-password" className="text-xs text-[#0096FF] hover:text-[#00D4FF]" data-testid="forgot-password-link">
                  Forgot password?
                </Link>
              </div>
              <input
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-4 py-3 bg-[#0A0A0A] border border-[#262626] rounded-md text-white placeholder-[#525252] focus:outline-none focus:border-[#0096FF] transition-colors"
                placeholder="Enter your password"
              />
            </div>

            <button
              data-testid="login-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full px-6 py-3 bg-[#0096FF] hover:bg-[#00D4FF] text-white font-semibold rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-[#9E9E9E]">
              Don't have an account?{' '}
              <Link to={`/register${returnUrl ? `?returnUrl=${encodeURIComponent(returnUrl)}` : ''}`} className="text-[#0096FF] hover:text-[#00D4FF] font-medium">
                Sign up
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
